import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { logout } from 'apps/customer/state/user';

import { setFromSms, setHasSeenDiscountSheet, setPromoShortCode } from './actions';

type PromoState = {
  fromSms: boolean;
  hasSeenDiscountSheet: boolean;
  savedShortCode: string;
};

const initialState: PromoState = {
  savedShortCode: '',
  hasSeenDiscountSheet: false,
  fromSms: false,
};

const store = createStore(initialState);

type Reducers = {
  setFromSms: {
    action: Event<boolean>;
    reducer: (state: PromoState, payload: boolean) => PromoState;
  };
  setHasSeenDiscountSheet: {
    action: Event<boolean>;
    reducer: (state: PromoState, payload: boolean) => PromoState;
  };
  setPromoShortCode: {
    action: Event<string>;
    reducer: (state: PromoState, payload: string) => PromoState;
  };
};

export const reducers: Reducers = {
  setPromoShortCode: {
    action: setPromoShortCode,
    reducer: (state, payload) => ({
      ...state,
      savedShortCode: payload,
    }),
  },
  setHasSeenDiscountSheet: {
    action: setHasSeenDiscountSheet,
    reducer: (state, payload) => ({
      ...state,
      hasSeenDiscountSheet: payload,
    }),
  },
  setFromSms: {
    action: setFromSms,
    reducer: (state, payload) => ({
      ...state,
      fromSms: payload,
    }),
  },
};

store.reset(logout.done);

export default applyReducers({ store, reducers });
